// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { LeftPanel } from '../Classes/LeftPanel';
import { ProjectViewPanel } from '../Classes/ProjectViewPanel';
export class ApplicationLastLayout {
  leftPanel: LeftPanel;
  lastActiveTab: number;
  projectViewPanel: ProjectViewPanel;
}
